$(document).ready(function(){

	// -- Vars --
	var loginForm = $('.craftcmsForm.form__login');
	var loginBtn = $('.craftcmsForm input[type="button"].btn__login');
	
	var registerForm = $('.craftcmsForm.form__register');
	var registerBtn = $('.craftcmsForm input[type="button"].btn__register');

	var forgotpasswordForm = $('.craftcmsForm.form__forgotpassword');
	var forgotpasswordBtn = $('.craftcmsForm .forgot__password a');

	// -- Action on login btn --
	loginBtn.on('click', function(e){
		$('.craftcmsForm').removeClass('active');
		loginForm.delay(400).addClass('active');
		resetNotifications();
	});

	// -- Action on register btn --
	registerBtn.on('click', function(e){
		$('.craftcmsForm').removeClass('active');
		registerForm.delay(400).addClass('active');
		resetNotifications();
	});

	// -- Action on forgot password link --
	forgotpasswordBtn.on('click', function(e){
		e.preventDefault();
		$('.craftcmsForm').removeClass('active');
		forgotpasswordForm.delay(400).addClass('active');
		resetNotifications();
	});


	$('.craftcmsForm .ajax__form').on('submit', function(e){
    // -- Config --
	  e.preventDefault();
    
    // -- Variables --
    var url = $(this).find('input[name="action"]').val();
    var redirect = $(this).find('input[name="redirect"]').val();
    var data = $(this).serialize();
    data[csrfTokenName] = csrfTokenValue;

    // -- Reset notifications --
    resetNotifications();

    // -- Ajax request --
    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json',
			beforeSend: function() { 
				// -- Disable submit action --
				$('.craftcmsForm .ajax__form').find('input[type="submit"]').attr('disabled', true);
			},
      success: function(response, statut){
        console.log(response);
				// -- Feedback --
				console.log(response.success);
				if (!response.success) { // ERROR
	        console.log('error');
	        // -- Display notifications --
		      $('.form__notifications').fadeIn();

		      if (response.errors) {
						$.each(response.errors, function(key, value) {
							var errorHtml = '<li class="error">' + value + '</li>';
							$('.form__notifications .errors').append(errorHtml);
						});

		      } else {
						$('.form__notifications .errors').html('<li class="error">' + response.error + '</li>');
		      }

	      } else { // SUCCESS
	      	console.log('success');
	        window.location.href = redirect;
	        // window.location.href = response.returnUrl;

	      }
				
				// -- Enable submit action --
				$('.craftcmsForm .ajax__form').find('input[type="submit"]').attr('disabled', false);
      },
      error: function(response, statut, error){
        console.log('Bad request');
        console.log(response);
      }
    });

	});


	function resetNotifications(){
    $('.form__notifications .errors').html('');
	}

});
